<template>
  <li class="flex flex-col bg-white shadow-1dp rounded p-15 tablet:p-20">
    <div class="flex items-start">
      <AvatarChip
        :initials="initials"
        :name-length="(membership.ownerName || '').length"
        background-color="#333333"
        color="#f8f8f8"
        :size="44"
        class="flex-shrink-0 text-lg"
      />
      <div class="flex-1 min-w-0 ml-12">
        <p
          :title="membership.ownerName"
          class="font-bold text-lg text-primary leading-tight truncate"
        >
          {{ membership.ownerName || 'Event owner' }}
        </p>
        <p
          v-if="membership.ownerEmail"
          data-private
          class="text-sm text-gray-600 leading-snug truncate mt-2"
        >
          {{ membership.ownerEmail }}
        </p>
        <p class="role-chip inline-flex items-center font-medium text-xs leading-none py-5 px-8 mt-8 rounded">
          <FontAwesomeIcon
            :icon="['fad', 'user-friends']"
            class="mr-5"
          />
          Your role: {{ membership.roleLabel }}
        </p>
      </div>
    </div>

    <RouterLink
      :to="{ name: 'Dashboard' }"
      class="events-link flex items-center text-sm text-primary border-t border-gray-200 pt-12 mt-15"
    >
      <FontAwesomeIcon
        :icon="['fad', 'calendar-day']"
        class="text-secondary-dark mr-8"
      />
      <span>{{ eventCount }} shared {{ eventCount === 1 ? 'event' : 'events' }}</span>
    </RouterLink>
  </li>
</template>

<script>
import AvatarChip from '@/components/AvatarChip';

export default {
  components: {
    AvatarChip,
  },
  props: {
    membership: {
      type: Object,
      required: true,
    },
  },
  computed: {
    initials() {
      const parts = (this.membership.ownerName || '?').trim().split(/\s+/);
      return ((parts[0] || '').charAt(0) + (parts.length > 1 ? parts[parts.length - 1].charAt(0) : '')).toUpperCase();
    },
    eventCount() {
      return this.membership.events.length;
    },
  },
};
</script>

<style scoped>
.role-chip {
  @apply text-secondary-dark bg-gray-200;
}

.events-link:hover span {
  @apply underline;
}
</style>
